<ng-container *transloco="let t; read: 'assignment'" >
    <h2>{{t('timeEntries')}}</h2>

    <ng-container *ngIf="vm$ | async as vm">
        <form
            [formGroup]="filterForm"
            class="flex flexDirRow justSpaceBetween twoCol"
        >
            <kendo-formfield>
                <kendo-label [text]="t('filterEmployee')"></kendo-label>
                <kendo-dropdownlist
                    formControlName="employee"
                    [data]="vm.employees"
                    textField="lastName"
                    valueField="id"
                    [valuePrimitive]="false"
                    [defaultItem]="employeeDefaultItem"
                >
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                        {{ dataItem?.id ? dataItem?.firstName + ' ' + dataItem?.lastName : t('filterAll') }}
                    </ng-template>
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                        {{ dataItem?.id ? dataItem?.firstName + ' ' + dataItem?.lastName : t('filterAll') }}
                    </ng-template>
                </kendo-dropdownlist>
            </kendo-formfield>

            <kendo-formfield>
                <kendo-label [text]="t('filterActivity')"></kendo-label>
                <kendo-dropdownlist
                    formControlName="timeEntryCategory"
                    [data]="vm.categories"
                    textField="name"
                    valueField="id"
                    [valuePrimitive]="false"
                    [defaultItem]="categoryDefaultItem"
                >
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                        {{ dataItem?.id ? dataItem?.name : t('filterAll') }}
                    </ng-template>
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                        {{ dataItem?.id ? dataItem?.name : t('filterAll') }}
                    </ng-template>
                </kendo-dropdownlist>
            </kendo-formfield>

            <kendo-daterange>
                <kendo-formfield>
                    <kendo-label [text]="t('filterDateFrom')"></kendo-label>
                    <kendo-dateinput
                        formControlName="dateRangeStart"
                        kendoDateRangeStartInput
                    ></kendo-dateinput>
                </kendo-formfield>
                <kendo-formfield>
                    <kendo-label [text]="t('filterDateTo')"></kendo-label>
                    <kendo-dateinput
                        formControlName="dateRangeEnd"
                        kendoDateRangeEndInput
                    ></kendo-dateinput>
                </kendo-formfield>
                <kendo-daterange-popup [animate]="false"></kendo-daterange-popup>
            </kendo-daterange>

            <div class="flexItem">
                <button
                    *ngIf="filterForm.dirty"
                    kendoButton
                    type="button"
                    fillMode="outline"
                    size="medium"
                    rounded="medium"
                    themeColor="primary"
                    (click)="onResetFilter()"
                >
                    {{ t('filterReset') }}
                </button>
            </div>
        </form>

        <app-time-entry-grid
            [isAdminView]="true"
            [totalTime]="vm.totalTime"
            [timeEntries]="vm.timeEntries"
            [assignment]="(assignment$ | async)"
            [searchRequest]="searchRequest"
            (onUpdateGrid)="updateList()"
        ></app-time-entry-grid>
    </ng-container>
</ng-container>
